import {
  arTaskAssigneeKey,
  type ArTaskRow,
  type ArTasksAssigneeGroup,
} from '@erp/rpc';

/**
 * The assignee group whose first row on the page is at `index` (its header
 * goes there), else null. The server orders grouped rows by assignee, so a
 * group's rows are contiguous; a group carried over from the previous page
 * gets its header again at the top.
 */
export function assigneeGroupStartingAt(
  rows: readonly Pick<
    ArTaskRow,
    'assigneeUserId' | 'assigneeAgentDefinitionId'
  >[],
  groups: readonly ArTasksAssigneeGroup[],
  index: number,
): ArTasksAssigneeGroup | null {
  const row = rows[index];
  if (!row) return null;
  const key = arTaskAssigneeKey(row);
  const previous = rows[index - 1];
  if (previous && arTaskAssigneeKey(previous) === key) return null;
  return groups.find((group) => group.key === key) ?? null;
}

/**
 * The group header checkbox's state from the page's selection: checked when
 * every one of the group's rows on the page is selected, indeterminate when
 * some are, else unchecked.
 */
export function groupSelectionState(
  rowIds: readonly string[],
  selection: Readonly<Record<string, boolean>>,
): boolean | 'indeterminate' {
  const selected = rowIds.filter((id) => selection[id]).length;
  if (selected === 0) return false;
  return selected === rowIds.length || 'indeterminate';
}

/** Columns the table hides for a grouping: the assignee is in each group's header. */
export function arTasksGroupHiddenColumns(
  groupBy: 'assignee' | undefined,
): Record<string, boolean> {
  return groupBy === 'assignee' ? { assignee: false } : {};
}
